import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  update_user_meta_data_action,
  update_user_timezone_action,
} from "../../../../redux/_actions";

import {
  get_candidate_profile_data_action,
  update_candidate_profile_action,
} from "../../../../redux/_actions/candidate";

import { GENDER, CURRENCY } from "../constants";
import { showWarningMessage } from "../../../../_uiComponents/ShowMessageSnack";
function usePersonalInformation(props) {
  const [userData, setUserData] = useState({});
  const [gender, setGender] = useState([]);
  const [formInputsError, setFormInputsError] = useState({});
  const [editResumeClicked, setEditResumeClicked] = useState(false);
  const [currency, setCurrency] = useState([]);

  const dispatch = useDispatch();

  //get data from redux
  const { userProfileData } = useSelector(
    (state) => state.get_candidate_profile_data_reducer
  );

  useEffect(() => {
    if (userProfileData?.data) {
      let data = userProfileData?.data;
      data["country"] = data["country_name"] && data["country_name"];
      data["state"] = data["state_name"] && data["state_name"];
      data["city"] = data["city_name"] && data["city_name"];
      setUserData(data);
    }
  }, [userProfileData]);

  //set dropdown choices
  useEffect(() => {
    setGender(GENDER);
    setCurrency(CURRENCY);
  }, []);

  //on input blurr for profile
  const onInputBlur = async (e) => {
    let value = e.target.value;
    let key = e.target.name;
    let data = {};
    data[key] = value;
    if (value) await dispatch(update_candidate_profile_action(data));
  };

  const onTimeZoneChange = async (e) => {
    let value = e.target.value;
    let key = e.target.name;
    let data = {};
    data[key] = value;
    await dispatch(update_user_timezone_action(data));
    await dispatch(get_candidate_profile_data_action());
  };

  const onImageUpload = async (e, key) => {
    const file = e.target.files[0];
    const name = e.target.name;
    const data = new FormData();
    data.append(name, file);
    if (file) {
      if (name === "resume") {
        if (file && file.type === "application/pdf") {
          await dispatch(update_user_meta_data_action(data));
          await dispatch(get_candidate_profile_data_action());
          setEditResumeClicked(false);
        } else {
          showWarningMessage("Please select a PDF file.");
        }
      } else {
        await dispatch(update_user_meta_data_action(data));
        await dispatch(get_candidate_profile_data_action());
        setEditResumeClicked(false);
      }
    }
  };

  const onDateChange = async (date) => {
    let convertDate = (date) => {
      var date = new Date(date),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    };
    let formatDate = convertDate(date);
    // if (formatDate.length)
    // await dispatch(update_candidate_profile_action({ dob: formatDate }));
  };

  const onResumeEditClick = () => setEditResumeClicked(!editResumeClicked);

  // onlocation change
  const onLocationChange = async (name, value) => {
    let data = userData;

    if (name === "country") {
      data["state"] = null;
      data["city"] = null;
    }

    if (name === "state") {
      data["city"] = null;
    }
    data[name] = value;
    if (value) {
      await dispatch(update_candidate_profile_action(data));
    }
  };

  return {
    userData,
    gender,
    formInputsError,
    editResumeClicked,
    currency,
    onImageUpload,
    onInputBlur,
    onDateChange,
    onResumeEditClick,
    onTimeZoneChange,
    onLocationChange,
  };
}
export default usePersonalInformation;
